function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "feedback");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "feedback"
}, /*#__PURE__*/React.createElement("g", {
  id: "message-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.45,57a2.54,2.54,0,0,1-1.28-.35A2.5,2.5,0,0,1,14,54.5V44.37a2.5,2.5,0,0,1,5,0V50.3l14.76-8a2.5,2.5,0,0,1,2.38,4.4l-18.45,10A2.5,2.5,0,0,1,16.45,57Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.5,47H34.9a2.5,2.5,0,0,1,0-5h5.6A13.52,13.52,0,0,0,54,28.5v-10A13.52,13.52,0,0,0,40.5,5h-22A13.52,13.52,0,0,0,5,18.5v10A13.52,13.52,0,0,0,16.77,41.89a2.5,2.5,0,1,1-.64,5A18.53,18.53,0,0,1,0,28.5v-10A18.52,18.52,0,0,1,18.5,0h22A18.52,18.52,0,0,1,59,18.5v10A18.52,18.52,0,0,1,40.5,47Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.5,27.71a2.5,2.5,0,0,1-2.5-2.5V13.5a2.5,2.5,0,0,1,5,0V25.21A2.5,2.5,0,0,1,29.5,27.71Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.5,36A2.5,2.5,0,0,1,27,33.5v-1a2.5,2.5,0,1,1,5,0v1A2.5,2.5,0,0,1,29.5,36Z"
})))));

var SvgFeedback = function SvgFeedback(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 59 57",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeedback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feedback.7350949f.svg";
export { ForwardRef as ReactComponent };